<template>
  <div
    class="nullable-date-picker"
    :class="{ invalid: invalid }"
    ref="datewrapper"
  >
    <div style="width: 18ch; position: relative;">
      <b-datepicker
        :placeholder="placeholder"
        @input="emitInput"
        v-model="date"
        ref="nullableDate"
        icon="calendar"
        locale="de-DE"
        :readonly="false"
      >
        <button
          class="button is-aquamarine"
          outlined
          @click="nullDate"
        >
          {{ placeholder }}
        </button>
      </b-datepicker>
      <span v-if="invalid" class="custom-icon has-text-danger">
        <i class="fa fa-exclamation-circle fa-lg"></i>
      </span>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        date: this.value,
      }
    },
    props: {
      value: Date,
      placeholder: String,
      invalid: {
        type: Boolean,
        default: false,
      },
    },
    mounted () {
      // we need to listen to 'mousedown' because some(?) input fields
      // stop the click event propagation
      document.body.addEventListener('mousedown', this.mouseClicked)
    },
    beforeDestroy () {
      document.body.removeEventListener('mousedown', this.mouseClicked)
    },
    methods: {
      nullDate () {
        // normally the date picker closes on it's own but not when the
        // date was null already
        this.closeDatePicker()
        this.date = null
      },
      emitInput () {
        this.closeDatePicker()
        this.$emit('input', this.date)
      },
      mouseClicked (e) {
        let input = this.$refs.datewrapper.getElementsByTagName('input')[0]
        // clicking the input field (i.e. mouse down, then mouse up) will toggle the
        // date picker by default. we don't want to close it prematurely on
        // mousedown because then it will reopen on mouse up
        let clickedInput = e.target === input

        // a nullClick happens when user selects something from a dropdown menu,
        // i.e. selects a year or a month. In this case, we don't want to close
        // the date picker just yet
        let nullClick = e.clientX === 0 && e.clientY === 0

        let ddMenus = this.$refs.datewrapper.getElementsByClassName('dropdown-menu')
        if (ddMenus && ddMenus.length > 0) {
          let rect = ddMenus[0].getBoundingClientRect()
          let mx = e.clientX - rect.left
          let my = e.clientY - rect.top
          let inside = mx >= 0 && mx <= rect.width && my >= 0 && my <= rect.height

          if (!inside && !nullClick && !clickedInput && this.$refs.nullableDate.$children[0].isActive) {
            this.$refs.nullableDate.$children[0].toggle()
          }
        }
      },
      closeDatePicker () {
        if (this.$refs.nullableDate.$children[0].isActive) {
          this.$refs.nullableDate.$children[0].toggle()
        }
      }
    }
  }
</script>

<style>
  .nullable-date-picker input::placeholder {
    color: black;
    opacity: 1;
  }

  .nullable-date-picker.invalid input {
    border-color: var(--red-2);
  }

  .nullable-date-picker.invalid input:focus {
    /*
      these color values for the shadow are of course baked into
      bulma/buefy and are only configurable at compile time
      (scss/sass compile time that is) instead of using real CSS
      variables that could be more easily changed
     */
    -webkit-box-shadow: 0 0 0 0.125em rgba(216, 65, 62, 0.25);
    box-shadow: 0 0 0 0.125em rgba(216, 65, 62, 0.25);
  }

  .custom-icon {
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    top: 0;
    right: 0;
    pointer-events: none;
    width: 2.25em;
    height: 2.25em;
    z-index: 4;
    text-align: left;
    font-size: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/NullableDate.vue